import Titulo from "../../components/atoms/titles/Titulo";
import DataTable from "react-data-table-component";
import ConstantesTabla from "../../utils/ConstantesTabla";
import { useEffect, useState } from "react";
import ButtonHelp from "../../components/atoms/buttons/ButtonHelp";
import PDF_AYUDA_CONCURSO_FUNCIONARIOS from "../../resources/pdf/concurso/ayuda/ayuda_concurso_funcionarios.pdf";
import PDF_AYUDA_TRASLADO_INFOEX_2023 from "../../resources/pdf/concurso/ayuda/ayuda_traslado_infoex_2023.pdf";
import PDF_AYUDA_TRASLADO_LABORALES from "../../resources/pdf/concurso/ayuda/ayuda_traslado_laborales.pdf";
import PDF_AYUDA_TRASLADO_NO_SINGULARIZADOS2 from "../../resources/pdf/concurso/ayuda/ayuda_traslado_no_singularizados2.pdf";
import { useNavigate, useParams } from "react-router-dom";
import {
  SpinnerCircle,
  SpinnerCircleMini,
} from "../../components/atoms/spinner/Spinner";
import {
  borraSolicitud,
  // generarReporte,
  // getCertificadosAgricultura,
  // getCertificadosEducacion,
  // getCertificadosExperiencia,
  getConcursosById,
  // getPDFEducacion,
  imprimirSolicitud,
  // getPDFSolicitudConcurso1,
  //getPDFSolicitudConcurso2,
  obtenerListadoSolicitudesEnPlazo,
  obtenerListadoSolicitudesFueraPlazo,
  validaSolicitud,
} from "../../components/services/ConcursosService";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import "./concursoPS.scss";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import Header from "../../components/molecules/header/Header";
import IfError from "../../components/molecules/ifError/IfError";
import Footer from "../../components/molecules/footer/Footer";
// import { getCertificadosRegistros } from "../../components/services/ConcursosService";

const ConcursoPuestosSingularizados = () => {
  const navigate = useNavigate();
  const params = useParams();
  const user = JSON.parse(localStorage.getItem("user"));
  // const [isInitialRender,setIsInitialRender] = useState(false)
  const [loading, setLoading] = useState(false);
  const [loadingTabla, setLoadingTabla] = useState(true);
  const [concurso, setConcurso] = useState({});
  const [concursoCerrado, setConcursoCerrado] = useState(false);
  const [disablePrint, setDisablePrint] = useState(false);
  const [solicitudes, setSolicitudes] = useState([]);
  const [error, setError] = useState(false);
  const [show, setShow] = useState({
    mensaje: false,
  });

  // const [certificados, setCertificados] = useState({
  //   registro: false,
  //   educacionImp: false,
  //   educacionRec: false,
  //   experiencia: false,
  //   agricultura: false,
  // });
  // const [certificadosRegistros, setCertificadosRegistros] = useState({});
  // const [certificadosEducacionRecibida, setCertificadosEducacionRecibida] =
  //   useState({});
  // const [certificadosEducacionImpartida, setCertificadosEducacionImpartida] =
  //   useState({});
  // const [certificadosExperiencia, setCertificadosExperiencia] = useState({});
  // const [certificadosAgricultura, setCertificadosAgricultura] = useState({});

  const generarPDFConcurso = (adscripcion, idsolicitud) => {
    

    
    navigate(
      `/descargaSolicitudConcurso/${params.id}/${idsolicitud}`
    );
    setDisablePrint(false);
    // switch (adscripcion) {
    //   case "F":
    //     getPDFSolicitudConcurso2(idsolicitud).then((data) => {
    //       
    //       if (!data.toString().startsWith("Error:")) {
    //         const file = new Blob([data], {
    //           type: "application/pdf",
    //         });
    //         // 
    //         if (file.size !== 0) {
    //           const fileURL = URL.createObjectURL(file);
    //           const link = document.createElement("a");
    //           link.href = fileURL;
    //           link.download = `CON_${adscripcion}_${idsolicitud}.pdf`;
    //           link.click();
    //           link.remove();
    //         } else {
    //           handleShow({
    //             mensaje: true,
    //             content:
    //               "CFNULL: No se ha podido imprimir correctamente el PDF",
    //             destinoAviso: null,
    //             destinoCerrar: null,
    //           });
    //         }
    //       } else {
    //         handleShow({
    //           mensaje: true,
    //           content: "CFERROR: No se ha podido imprimir correctamente el PDF",
    //           destinoAviso: null,
    //           destinoCerrar: null,
    //         });
    //       }
    //       setDisablePrint(false);
    //     });
    //     break;
    //   case "L":
    //     getPDFSolicitudConcurso1(idsolicitud).then((data) => {
    //       
    //       if (!data.toString().startsWith("Error:")) {
    //         const file = new Blob([data], {
    //           type: "application/pdf",
    //         });
    //         // 
    //         if (file.size !== 0) {
    //           const fileURL = URL.createObjectURL(file);
    //           const link = document.createElement("a");
    //           link.href = fileURL;
    //           link.download = `CON_${adscripcion}_${idsolicitud}.pdf`;
    //           link.click();
    //           link.remove();
    //         } else {
    //           handleShow({
    //             mensaje: true,
    //             content:
    //               "CLNULL: No se ha podido imprimir correctamente el PDF",
    //             destinoAviso: null,
    //             destinoCerrar: null,
    //           });
    //         }
    //       } else {
    //         handleShow({
    //           mensaje: true,
    //           content: "CLERROR: No se ha podido imprimir correctamente el PDF",
    //           destinoAviso: null,
    //           destinoCerrar: null,
    //         });
    //       }
    //       setDisablePrint(false);
    //     });
    //     break;
    //   default:
    //     setShow({
    //       mensaje: true,
    //       content: "CNULL: No se ha podido imprimir correctamente el PDF",
    //       destinoAviso: null,
    //       destinoCerrar: null,
    //     });
    //     break;
    // }
  };

  const handleValidacion = (codigo) => {
    validaSolicitud(codigo).then((data) => {
      
    });
  };

  const setValidada = (row) => {
    row.validada = "S";
  };

  const handleBorrado = (codigo) => {
    borraSolicitud(codigo).then((data) => {
      
      setSolicitudes(solicitudes.filter((el) => el.idsolicitud !== codigo));
    });
  };

  const handleShow = (e) => {
    setShow(e);
  };

  const handleClose = (e) => {
    setShow(false);
  };

  //acciones para cuando el concurso esté en plazo
  //hey
  const accionesCons = [
    {
      name: "Consultar/Modificar",
      grow: 1.1,
      center: true,
      cell: (row) =>
        row.validada === "N" ? (
          <i
            className="fa-solid fa-pencil fs-3 mx-2 px-3 cursorPointer faHover"
            role="button"
            title="Modificación de la solicitud"
            aria-label="Botón para la modificación de la solicitud en concursos de traslados" // Pequeña de descripcion más amplia del botón
            onClick={() => {
              
              navigate(
                `/consModSolicitudes/${concurso.cbpxcabpro}/${row.idsolicitud}`
              );
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                navigate(
                  `/consModSolicitudes/${concurso.cbpxcabpro}/${row.idsolicitud}`
                );
              }

            }}
            tabIndex={0}
          ></i>
        ) : row.validada === "S" ? (
          <i className="fa-solid fa-pencil fs-3 mx-2 px-3 faDisable"></i>
        ) : null,
    },
    {
      name: "Borrar",
      center: true,
      cell: (row) =>
        row.validada === "N" ? (
          <i
            className="fa-solid fa-x fs-3 mx-2 px-3 cursorPointer faHover"
            role="button"
            title="Borrado de la solicitud"
            aria-label="Botón para el borrado de la solicitud en concursos de traslados"
            onClick={() =>
              handleShow({
                mensaje: true,
                otherContent: "¿Desea continuar?",
                texto:
                  "Se dispone a eliminar la solicitud correspondiente a la convocatoria, junto con los anexos que la forman. Una vez eliminada esta información no podrá recuperarla.",
                tipo: "tituloModal",
                aviso: true,
                funcion: handleBorrado,
                valorFuncion: row.idsolicitud,
                destinoAviso: null,
              })
            }
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                handleShow({
                  mensaje: true,
                  otherContent: "¿Desea continuar?",
                  texto: "Se dispone a eliminar la solicitud correspondiente a la convocatoria, junto con los anexos que la forman. Una vez eliminada esta información no podrá recuperarla.",
                  tipo: "tituloModal",
                  aviso: true,
                  funcion: handleBorrado,
                  valorFuncion: row.idsolicitud,
                  destinoAviso: null,
                })
              }

            }}
            tabIndex={0}
          ></i>
        ) : row.validada === "S" ? (
          <i className="fa-solid fa-x fs-3 mx-2 px-3 faDisable"></i>
        ) : null,
    },
    {
      name: "Validar",
      center: true,
      cell: (row) =>
        row.validada === "N" ? (
          <i
            className="fa-solid fa-check fs-3 mx-2 px-3 cursorPointer faHover"
            role="button"
            title="Validación de la solicitud"
            aria-label="Botón para el validado de la solicitud en concursos de traslados"
            onClick={() => {
              handleShow({
                mensaje: true,
                // otherContent: (<><div className="mt-3 verde fs-4 fw-bold">¿Desea continuar?</div></>),
                otherContent: "¿Desea continuar?",
                texto:
                  "Se dispone a validar la solicitud correspondiente a la convocatoria. No podrá modificarla una vez validada.",
                tipo: "tituloModal",
                aviso: true,
                funcion: handleValidacion,
                valorFuncion: row.idsolicitud,
                destinoAviso: null,
                funcion2: setValidada,
                valorFuncion2: row,
              });
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                handleShow({
                  mensaje: true,
                  titulo: "¿Desea continuar?",
                  otherContent:
                    "Se dispone a validar la solicitud correspondiente a la convocatoria. No podrá modificarla una vez validada.",
                  tipo: "tituloModal",
                  aviso: true,
                  funcion: handleValidacion,
                  valorFuncion: row.idsolicitud,
                  destinoAviso: null,
                  funcion2: setValidada,
                  valorFuncion2: row,
                });
              }

            }}
            tabIndex={0}
          ></i>
        ) : row.validada === "S" ? (
          <i className="fa-solid fa-check fs-3 mx-2 px-3 faDisable" />
        ) : null,
    },
    //  {
    //   name: "Presentar",
    //   center: true,
    //   cell: (row) =>
    //     row.validada === "N" ? (
    //       <i
    //         className="fa-solid fa-file-powerpoint fs-3 mx-2 px-3 cursorPointer faHover"
    //         role="button"
    //         title="Presentar Solicitud"
    //         aria-label="Botón para el presentado de la solicitud en concursos de traslados"
    //         onClick={() => {
    //           // handleShow({
    //           //   mensaje: true,
    //           //   // otherContent: (<><div className="mt-3 verde fs-4 fw-bold">¿Desea continuar?</div></>),
    //           //   otherContent: "¿Desea continuar?",
    //           //   texto:
    //           //     "Se dispone a validar la solicitud correspondiente a la convocatoria. No podrá modificarla una vez validada.",
    //           //   tipo: "tituloModal",
    //           //   aviso: true,
    //           //   funcion: handleValidacion,
    //           //   valorFuncion: row.idsolicitud,
    //           //   destinoAviso: null,
    //           //   funcion2: setValidada,
    //           //   valorFuncion2: row,
    //           // });
    //           navigate(`/presentarSolicitudConcursos/${concurso.cbpxcabpro}/${row.idsolicitud}`)
    //         }}
    //         onKeyDown={(e) => {
    //           if (e.key === "Enter" || e.key === " ") {
    //             e.preventDefault()
    //           //   handleShow({
    //           //     mensaje: true,
    //           //     titulo: "¿Desea continuar?",
    //           //     otherContent:
    //           //       "Se dispone a validar la solicitud correspondiente a la convocatoria. No podrá modificarla una vez validada.",
    //           //     tipo: "tituloModal",
    //           //     aviso: true,
    //           //     funcion: handleValidacion,
    //           //     valorFuncion: row.idsolicitud,
    //           //     destinoAviso: null,
    //           //     funcion2: setValidada,
    //           //     valorFuncion2: row,
    //           //   });
    //             navigate(`/presentarSolicitudConcursos/${concurso.cbpxcabpro}/${row.idsolicitud}`)
    //           }

    //         }}
    //         tabIndex={0}
    //       ></i>
    //     ) : row.validada === "S" ? (
    //       <i className="fa-solid fa-check fs-3 mx-2 px-3 faDisable" />
    //     ) : null,
    // },
    {
      name: "Imprimir",
      center: true,
      cell: (row) =>
        !disablePrint ? (
          <>
            {" "}
            <i
              className={"fa-solid fa-print fs-3 mx-2 px-3 cursorPointer faHover"}
              role="button"
              title="Visualización y obtención de un PDF de la solicitud"
              aria-label="Botón para la visualización y obtención de un PDF de la solicitud en concursos de traslados"
              onClick={() => {
                // generarPDFConcurso1();
                imprimirSolicitud(row.codconcurso, row.idsolicitud).then((data) => {
                  
                  const file = new Blob([data], { type: "application/pdf" });
                  const fileURL = URL.createObjectURL(file);
                  window.open(fileURL, "_blank"); // abre el PDF en otra pestaña
                })
                // generarReporte()
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  imprimirSolicitud(row.codconcurso, row.idsolicitud).then((data) => {
                    
                    const file = new Blob([data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL, "_blank"); // abre el PDF en otra pestaña
                    // window.open(data.url)
                  })
                }

              }}
              tabIndex={0}
            />
          </>
        ) : (
          <>
            <SpinnerCircleMini></SpinnerCircleMini>
          </>
        ),
    },
  ];

  //acciones para cuando el concurso esté plazo cerrado

  const accionesCerrado = [
    {
      name: "Estado",
      grow: 1.1,
      center: true,
      cell: (row) =>
        row.vestado === "A" ? (
          <p>Admitida</p>
        ) : row.vestado ? (
          <p>Rechazada</p>
        ) : null,
    },
    {
      name: "Imprimir",
      center: true,
      cell: (row) =>
        !disablePrint ? (
          <>
            {" "}
            <i
              className={"fa-solid fa-print fs-3 mx-2 px-3 cursorPointer faHover"}
              role="button"
              title="Visualizacion de un PDF de la solicitud en un concurso cerrado"
              aria-label="Generación de un pdf para la visualización de los datos la solicitud en un concurso cerrado"
              onClick={() => {
                // generarPDFConcurso1();
                generarPDFConcurso(concurso.adscripcion, row.idsolicitud);
                setDisablePrint(true);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  generarPDFConcurso(concurso.adscripcion, row.idsolicitud);
                  setDisablePrint(true);
                }
              }}
              tabIndex={0}
            />
          </>
        ) : (
          <>
            <SpinnerCircleMini></SpinnerCircleMini>
          </>
        ),
    },
  ];

  useEffect(() => {

    getConcursosById(params.id).then((data) => {
      

      if (!data) {
        navigate("/concursos");
      } else {
        let hoy = new Date();
        let finConcurso = new Date(data.ffinal);
        // let hoy = new Date(2022, 0, 1); // para cuando se quiera establecer una fecha para ver el concurso sin que esté cerrado
        
        
        

        if (hoy.getTime() > finConcurso.getTime()) {
          setConcursoCerrado(true);
          //ANOTACION v_tipcnvo --> tipo de convocatoria/concurso posiblemente
          //habilitar los certificados cuando esten bien definidos los servicios
          // getCertificadosRegistros(params.id, user.niep, true).then((data) => {
          //   if (!data.toString().startsWith("Error:")) {
          //     setCertificados((prevState) => ({
          //       ...prevState,
          //       registro: true,
          //     }));
          //     setCertificadosRegistros({
          //       name: <div>Certificación del R.G.P.</div>,
          //       grow: 1.1,
          //       center: true,
          //       cell: (row, index) =>
          //         row.vestado === "A" ? (
          //           <i
          //             className={
          //               "fa-solid fa-eye fs-3 mx-2 px-3 cursorPointer faHover"
          //             }
          //             onClick={() => {
          //               
          //             }}
          //             onKeyDown={(e) => {
          //               if (e.key === "Enter" || e.key === " ") {
          //                 e.preventDefault()
          //                 
          //               }
          //             }}
          //             tabIndex={0}
          //             role="button"
          //             title="Certificación del R.G.P."
          //             aria-label="Ver Certificación del R.G.P."
          //           />
          //         ) : null,
          //     });
          //   }
          // });
          // getCertificadosEducacion(params.id, user.niep).then((data) => {
          //   if (!data.toString().startsWith("Error:")) {
          //     data.forEach((cert) => {
          //       if (cert.formacion === "Recibida") {
          //         setCertificados((prevState) => ({
          //           ...prevState,
          //           educacionRec: true,
          //         }));
          //       } else if (cert.formacion === "Impartida") {
          //         setCertificados((prevState) => ({
          //           ...prevState,
          //           educacionImp: true,
          //         }));
          //       }
          //     });
          //     setCertificadosEducacionRecibida({
          //       name: <div>Certificación de la E.A.P. Recibida</div>,
          //       grow: 1.1,
          //       center: true,
          //       cell: (row) =>
          //         row.vestado === "A" ? (
          //           <i
          //             className={
          //               "fa-solid fa-eye fs-3 mx-2 px-3 cursorPointer faHover"
          //             }
          //             role="button"
          //             title="Certificación de la E.A.P. Recibida"
          //             aria-label="Certificación de la E.A.P. Recibida"
          //             onClick={() => {
          //               
          //               getPDFEducacion(data[0].nombreFichero).then((data2) => {
          //                 if (!data2.toString().startsWith("Error:")) {
          //                   const file = new Blob([data2], {
          //                     type: "application/pdf",
          //                   });

          //                   if (file.size !== 0) {
          //                     // setDescargandoPDF(false);
          //                     const fileURL = URL.createObjectURL(file);
          //                     const link = document.createElement("a");
          //                     link.href = fileURL;
          //                     link.download = `${data[0].nombreFichero}.pdf`;
          //                     link.click();
          //                     // link.remove();
          //                     
          //                     // setShowFeedback(false);
          //                   } else {
          //                     // setShowFeedback(true);
          //                   }
          //                 }
          //               });
          //             }}
          //             onKeyDown={(e) => {
          //               if (e.key === "Enter" || e.key === " ") {
          //                 e.preventDefault()
          //                 getPDFEducacion(data[0].nombreFichero).then((data2) => {
          //                   if (!data2.toString().startsWith("Error:")) {
          //                     const file = new Blob([data2], {
          //                       type: "application/pdf",
          //                     });

          //                     if (file.size !== 0) {
          //                       // setDescargandoPDF(false);
          //                       const fileURL = URL.createObjectURL(file);
          //                       const link = document.createElement("a");
          //                       link.href = fileURL;
          //                       link.download = `${data[0].nombreFichero}.pdf`;
          //                       link.click();
          //                       // link.remove();
          //                       
          //                       // setShowFeedback(false);
          //                     } else {
          //                       // setShowFeedback(true);
          //                     }
          //                   }
          //                 });
          //               }
          //             }}
          //             tabIndex={0}
          //           />
          //         ) : null,
          //     });
          //     setCertificadosEducacionImpartida({
          //       name: <div>Certificación de la E.A.P. Impartida</div>,
          //       grow: 1.1,
          //       center: true,
          //       cell: (row) =>
          //         row.vestado === "A" ? (
          //           <i
          //             className={
          //               "fa-solid fa-eye fs-3 mx-2 px-3 cursorPointer faHover"
          //             }
          //             role="button"
          //             title="Certificación de la E.A.P. Impartida"
          //             aria-label="Certificación de la E.A.P. Impartida"
          //             onClick={() => {
          //               
          //             }}
          //             onKeyDown={(e) => {
          //               if (e.key === "Enter" || e.key === " ") {
          //                 e.preventDefault()
          //                 
          //               }
          //             }}
          //             tabIndex={0}
          //           />
          //         ) : null,
          //     });
          //   }
          // });
          // getCertificadosExperiencia(params.id, user.niep).then((data) => {
          //   if (!data.toString().startsWith("Error:")) {
          //     setCertificados((prevState) => ({
          //       ...prevState,
          //       experiencia: true,
          //     }));
          //     setCertificadosExperiencia({
          //       name: <div>Certificación Experiencia</div>,
          //       grow: 1.1,
          //       center: true,
          //       cell: (row) =>
          //         row.vestado === "A" ? (
          //           <i
          //             className={
          //               "fa-solid fa-eye fs-3 mx-2 px-3 cursorPointer faHover"
          //             }
          //             role="button"
          //             title="Certificación Experiencia"
          //             aria-label="Certificación Experiencia"
          //             onClick={() => {
          //               
          //             }}
          //             onKeyDown={(e) => {
          //               if (e.key === "Enter" || e.key === " ") {
          //                 e.preventDefault()
          //                 
          //               }
          //             }}
          //             tabIndex={0}
          //           />
          //         ) : null,
          //     });
          //   }
          // });
          // getCertificadosAgricultura(params.id, user.niep).then((data) => {
          //   if (!data.toString().startsWith("Error:")) {
          //     setCertificados((prevState) => ({
          //       ...prevState,
          //       agricultura: true,
          //     }));
          //     setCertificadosAgricultura({
          //       name: <div>Certificación Agricultura</div>,
          //       grow: 1.1,
          //       center: true,
          //       cell: (row) =>
          //         row.vestado === "A" ? (
          //           <i
          //             className={
          //               "fa-solid fa-eye fs-3 mx-2 px-3 cursorPointer faHover"
          //             }
          //             role="button"
          //             title="Certificación Agricultura"
          //             aria-label="Certificación Agricultura"
          //             onClick={() => {
          //               
          //             }}
          //             onKeyDown={(e) => {
          //               if (e.key === "Enter" || e.key === " ") {
          //                 e.preventDefault()
          //                 
          //               }
          //             }}
          //             tabIndex={0}
          //           />
          //         ) : null,
          //     });
          //   }
          // });
          obtenerListadoSolicitudesFueraPlazo(params.id).then((data) => {
            setSolicitudes(data);
            
            if (data.toString().startsWith("Error:")) {
              setError(true);
            } else {
              setLoadingTabla(false);
            }
          });
        } else {
          obtenerListadoSolicitudesEnPlazo(params.id).then((data) => {
            

            setSolicitudes(data);
            
            if (data.toString().startsWith("Error:")) {
              setError(true);
            } else {
              setLoadingTabla(false);
            }
          });
        }
        setConcurso(data);
        if (!data.toString().startsWith("Error:")) {
          setLoading(true);
        }
      }
    });
  }, [concursoCerrado, navigate, params.id, user.niep]);

  // const certificadosCerrado = () => {
  //   const columnsCerrado = [
  //     ConstantesTabla.columnasSolicitudesConcursos,
  //     ...accionesCerrado
  //     // ...(certificados.registro ? [certificadosRegistros] : []),
  //     // ...(certificados.educacionRec ? [certificadosEducacionRecibida] : []),
  //     // ...(certificados.educacionImp ? [certificadosEducacionImpartida] : []),
  //     // ...(certificados.experiencia ? [certificadosExperiencia] : []),
  //     // ...(certificados.agricultura ? [certificadosAgricultura] : []),
  //   ];

  //   return columnsCerrado;
  // };

  return (
    <>
      <Header></Header>
      {loading ? (
        <>
          <div className="container-concursoPS pb-5" role="main" data-landmark-index="4">
            <Titulo
              tipo={"tituloPagina"}
              titulo={
                concurso.adscripcion === "F"
                  ? concurso.vtipcnvo === "B"
                    ? <h2 className="tituloPagina">Concurso Puestos No Singularizados</h2>
                    : <h2 className="tituloPagina">Concurso Puestos Singularizados</h2>
                  : concurso.adscripcion === "L"
                    ? <h2 className="tituloPagina">Traslado Personal Laboral</h2>
                    : <h2 className="tituloPagina">Concurso Puestos Singularizados</h2>
              }
            />
            <div
              className={
                concursoCerrado ? "concursoCerrado " : "titulos "
              }
            >
              <div className="tit1">
                <Titulo
                  clases={""}
                  tipo="tituloPagina2"
                  titulo={"Convocatoria: "}
                />
              </div>
              <div className="contenidoTit1">
                <p>{concurso.dconvocator}</p>
              </div>

              <div className="tit2">
                <Titulo
                  tipo="tituloPagina2"
                  titulo={"Plazo de Solicitudes: "}
                />
              </div>
              <div className="contenidoTit2">
                <p className="">
                  {concursoCerrado ? (
                    <>Cerrado</>
                  ) : (
                    <>
                      PLAZO DE PRESENTACIÓN DE SOLICITUDES DE{" "}
                      <span>{concurso.fini}</span> HASTA{" "}
                      <span>{concurso.ffin}</span> INCLUIDO
                    </>
                  )}
                </p>
              </div>
              {concursoCerrado ? null : (
                <>
                  <div className="botonAyuda">
                    <ButtonHelp
                      clases="btn-red btn-doc-ayuda"
                      nombre="Documento de ayuda"
                      funcion={() => {
                        switch (concurso.vtipcnvo) {
                          case "F":
                            window.open(PDF_AYUDA_CONCURSO_FUNCIONARIOS);
                            break;
                          case "B":
                            window.open(PDF_AYUDA_TRASLADO_NO_SINGULARIZADOS2);
                            break;
                          case "L":
                            window.open(PDF_AYUDA_TRASLADO_LABORALES);
                            break;
                          case "I":
                            window.open(PDF_AYUDA_TRASLADO_INFOEX_2023);
                            break;
                          default:
                            handleShow({
                              mensaje: true,
                              titulo:
                                "No hay documento de ayuda disponible para este concurso.",
                              tipo: "tituloModal",
                              destinoCerrar: "",
                            });
                            break;
                        }
                      }}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="vistaSolicitudes ">
              <div className="botonNuevaSol">
                <div className="container d-flex flex-column">
                  <i className="fa-solid fa-caret-right my-2">
                    <span className="text-black">
                      {" "}
                      Este es el listado de solicitudes que usted ha presentado.
                    </span>
                  </i>
                </div>
                
                <div className="container tablaSolicitudes card">
                  {loadingTabla ? (
                    <SpinnerCircle></SpinnerCircle>
                  ) : (
                    <DataTable
                      className="table-responsive"
                      columns={
                        !concursoCerrado
                          ? [
                            ConstantesTabla.columnasSolicitudesConcursos,
                            ...accionesCons,
                          ]
                          : accionesCerrado
                          //  certificadosCerrado(certificados) // acciones cerrado esta dentro del mapeo de los certificados cuando esten
                      }
                      data={solicitudes}
                      pagination
                      paginationComponentOptions={ConstantesTabla.paginacionOpt}
                      noDataComponent={
                        <span>No se encontró ninguna solicitud</span>
                      }
                      customStyles={ConstantesTabla.customStyles}
                      fixedHeader
                      fixedHeaderScrollHeight="600px"
                      style={{ marginTop: "20px" }}
                    />
                  )}
                </div>
                <div className="mb-3 row align-items-center">
                  <div className="col-md-6 order-1 order-md-0">
                    <button
                      id="volver"
                      className="btnRed rounded btnCancelarDocumentacion botonVolverConcurso"
                      type="button"
                      onClick={() => {
                        navigate(`/concursos`)
                      }}
                    >
                      <i className="fa-solid fa-rotate-left"></i> Volver
                    </button>
                  </div>

                  {concursoCerrado ? null : (
                    <>
                      <div className="col-md-6 order-0 order-md-1">
                        {/* <Button
                          id="btnNuevaSolicitudNC"
                          clases="btn-card seleccion-mes"
                          nombre={
                            <>
                              <i className="fa-solid fa-file-circle-plus"></i>{" "}
                              Nueva Solicitud
                            </>
                          }
                          tipo="button"
                          funcion={() =>
                            concurso.adscripcion === "F"
                              ? navigate(`/anexoii_1/${params.id}`)
                              : concurso.adscripcion === "L"
                                ? navigate(`/anexoi_1/${params.id}`)
                                : null
                          }
                        /> */}
                        <button
                          id="btnNuevaSolicitudNC"
                          className="btn rounded botonVolverConcurso"
                          type="button"
                          onClick={() =>
                            concurso.adscripcion === "F"
                              ? navigate(`/anexoii_1/${params.id}`)
                              : concurso.adscripcion === "L"
                                ? navigate(`/anexoi_1/${params.id}`)
                                : null
                          }
                        >
                          <i className="fa-solid fa-file-circle-plus"></i>{" "}Nueva Solicitud
                        </button>
                      </div>

                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="vistaSolicitudes   p-2">
              <p>
                Teléfonos de consulta para la resolución de dudas en relación
                con el contenido de los certificados:
              </p>
              <p>
                <span className="fw-bold text-black">
                  Certificación del R.G.P.:
                </span>{" "}
                924170135, 924170136
              </p>
              <p>
                <span className="fw-bold text-black">
                  Certificación de la E.A.P.:
                </span>{" "}
                924008102, 924008100{" "}
              </p>
            </div>
            {show.mensaje ? (
              <ModalMensajes
                show={show.mensaje}
                handleClose={handleClose}
                titulo={show.titulo}
                tipo={show?.tipo}
                texto={show?.texto}
                content={show?.content}
                content2={show?.content2}
                contentBold={show?.contentBold}
                otherContent={show?.otherContent}
                aviso={show?.aviso}
                destinoAviso={show?.destinoAviso}
                funcion={show?.funcion}
                valorFuncion={show?.valorFuncion}
                funcion2={show?.funcion2}
                valorFuncion2={show?.valorFuncion2}
                destinoCerrar={show?.destinoCerrar}
              ></ModalMensajes>
            ) : null}
          </div>
        </>
      ) : error ? (
        <>
          <div className="error errorConcurso rojo fs-4 pt-2 d-flex align-items-center flex-column my-auto" role="main" data-landmark-index="4">
            <IfError
              mensage="Error: Fallo en intentar obtener los datos del concurso."
              ruta="/home"
            ></IfError>
          </div>
        </>
      ) : (
        <>
          <div className="error loadingConcurso rojo fs-4 pt-2 d-flex align-items-center justify-content-center flex-column my-auto w-200" role="main" data-landmark-index="4">
            <SpinnerCircle></SpinnerCircle>
          </div>
        </>
      )}
      <Footer></Footer>
    </>
  );
};

export default ConcursoPuestosSingularizados;
